<template>
  <div class="page">
    <nav-bar/>
    <search-bar/>

    <div class style="width: 100%;">
      <div class="page-content">
        <div class="left">
          <div class="menu">

            <div
                class="menu-item"
                :class="current_url==='/me/profile'?'active':''"
                @click="go('/me/profile')"
            >个人资料
            </div>

            <div
                v-if="hasPermission(3)"
                class="menu-item"
                :class="current_url==='/me/myorder'?'active':''"
                @click="go('/me/myorder')"
            >我的订单
            </div>

            <div
                v-if="hasPermission(15)"
                class="menu-item"
                :class="current_url==='/me/salesOrder'?'active':''"
                @click="go('/me/salesOrder')"
            >销售订单
            </div>

            <div
                v-if="hasPermission(21)"
                class="menu-item"
                :class="current_url==='/me/merchantsOrder'?'active':''"
                @click="go('/me/merchantsOrder')"
            >供应商订单
            </div>

            <!-- 客户服务订单 -->
            <div
                v-if="hasPermission(3)"
                class="menu-item"
                :class="current_url==='/me/myservice'?'active':''"
                @click="go('/me/myservice')"
            >客户服务订单
            </div>

            <!-- 技术服务订单 -->
            <div
                v-if="hasPermission([785,760])"
                class="menu-item"
                :class="current_url==='/me/technician'?'active':''"
                @click="go('/me/technician')"
            >技术服务订单
            </div>
            <!-- 销售服务订单 -->
            <div
                v-if="hasPermission([17,700])"
                class="menu-item"
                :class="current_url==='/me/salesservice'?'active':''"
                @click="go('/me/salesservice')"
            >销售服务订单
            </div>
            <!-- 买家 || 供应商-->
            <div
                v-if="hasPermission(9) || hasPermission(20)"
                class="menu-item"
                @click="go('/me/myInformation')"
                :class="current_url==='/me/myInformation'?'active':''"
            >我的文章
            </div>
            <div
                v-if="hasPermission(5)"
                class="menu-item"
                :class="current_url.indexOf('/me/invoice')!='-1'?'active':''"
                @click="go('/me/invoice')"
            >我的发票
            </div>
            <div
                v-if="hasPermission(7)"
                :class="current_url.indexOf('/me/myaddress')!='-1'?'active':''"
                class="menu-item"
                @click="go('/me/myaddress')"
            >我的地址
            </div>
            <!-- 买家-->
            <div
                v-if="hasPermission(2) && false"
                class="menu-item"
                :class="current_url.indexOf('/me/mycontract')!='-1'?'active':''"
                @click="go('/me/mycontract')"
            >我的合同
            </div>
            <!-- 供应商-->
            <div
                v-if="hasPermission(19) && false"
                class="menu-item"
                @click="go('/me/merchantsContract')"
                :class="current_url.indexOf('/me/merchantsContract')!='-1'?'active':''"
            >我的合同
            </div>
            <div
                v-if="hasPermission(42222)"
                class="menu-item"
                :class="current_url.indexOf('/me/mydevice')!='-1'?'active':''"
                @click="go('/me/mydevice')"
            >我的设备
            </div>
            <div
                v-if="hasMemberType([2,3])"
                class="menu-item"
                :class="current_url.indexOf('/me/workmate')!='-1'?'active':''"
                @click="go('/me/workmate')"
            >我的同事
            </div>
            <div
                v-if="hasPermission(6)"
                class="menu-item"
                :class="current_url.indexOf('/me/finance')!='-1'?'active':''"
                @click="go('/me/finance')"
            >财务管理
            </div>

            <div
                v-if="hasPermission([637,332])"
                class="menu-item"
                @click="go('/me/myCustomer')"
                :class="current_url.indexOf('/me/myCustomer')!='-1'?'active':''"
            >我的客户
            </div>
            <div
                v-if="hasPermission([12,333,781])"
                class="menu-item"
                @click="go('/me/myIncome')"
                :class="current_url.indexOf('/me/myIncome')!='-1'?'active':''"
            >我的收益
            </div>
            <div
                v-if="hasPermission([783,779])"
                class="menu-item"
                :class="current_url.indexOf('/me/mybankcard')!='-1'?'active':''"
                @click="go('/me/mybankcard')"
            >我的银行卡
            </div>
            <div
                v-if="hasPermission([668,334])"
                class="menu-item"
                @click="go('/me/myRelation')"
                :class="current_url.indexOf('/me/myRelation')!='-1'?'active':''"
            >我的团队
            </div>
            <!-- <div
                v-if="hasPermission(14)"
                class="menu-item"
                :class="current_url.indexOf('/me/qrcode')!='-1'?'active':''"
                @click="go('/me/qrcode')"
            >我的二维码</div>-->
            <div
                v-if="hasPermission([16,697])"
                class="menu-item"
                :class="current_url.indexOf('/me/guarantee')!='-1'?'active':''"
                @click="go('/me/guarantee')"
            >我的担保
            </div>
          </div>
        </div>
        <div class="right">
          <router-view class/>
        </div>
      </div>
    </div>

    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  props: {},
  data() {
    return {
      current_url: "",
      memberInfo: this.$store.state.memberInfo
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        this.current_url = v.path;
      }
    }
  },
  methods: {},
  components: {
    "nav-bar": NavBar,
    "search-bar": SearchBar,
    "footer-bar": FooterBar
  }
};
</script>

<style scoped lang="scss">
.page-content {
  width: 1200px;
  margin: 20px auto;
  display: flex;
  background-color: #ffffff;

  .left {
    width: 200px;
    min-height: 800px;

    background: rgba(69, 142, 246, 1);

    .menu {
      width: 100%;
      /*height: 828px;*/
      opacity: 1;

      .menu-item {
        padding: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        cursor: pointer;
        height: 55px;
      }
    }
  }

  .right {
    width: 1000px;
    padding: 20px;
    height: 100%;
  }
}

.active {
  font-size: 20px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/page/me/index/index.vue